/**
 * Bunny shared constants — client side.
 *
 * Mirrors functions/bunny/bunnyConstants.js. The two files MUST stay in
 * sync; they can't share a module because src/ and functions/ are
 * separate npm projects with their own dependency trees.
 */

export const BUNNY_UPLOAD_CONTEXT = Object.freeze({
  ASSET: 'asset',
  REVIEW_VERSION: 'review_version',
  TEMP_ATTACHMENT: 'temp_attachment',
  USER_PROFILE: 'user_profile',
  // Company-level documents (contract PDFs). Admin-only, and deliberately
  // NOT an `asset` — contracts store a bare path and never get an assets doc.
  COMPANY_DOCUMENT: 'company_document',
});

/**
 * Folder names under the Bunny `app/` prefix. Kebab-case to match the company
 * slugs used everywhere else in the zone.
 *
 * buildBunnyAppAttachmentPath re-normalizes whatever it receives, so a stale
 * client sending the old snake_case values still lands in the right folder.
 */
export const BUNNY_APP_NAMESPACE = Object.freeze({
  CONVERSATION: 'conversations',
  DELIVERABLE_DISCUSSION: 'deliverable-discussions',
  FEEDBACK_SCREENSHOT: 'feedback-screenshots',
});

export const BUNNY_URL_INTENT = Object.freeze({
  PLAYBACK: 'playback',
  THUMBNAIL: 'thumbnail',
  DOWNLOAD: 'download',
});

/**
 * Bunny Stream transcode-status vocabulary as written to bunnyStream.status.
 * NOTE: status is unreliable for "is it playable" — Bunny can park status
 * below READY even when the encode is 100% done. Use isBunnyPlayable()
 * (variant-based) in assetUtils for the deterministic playable check; use
 * these constants only for the explicit FAILED state and string comparisons.
 */
export const BUNNY_STREAM_STATUS = Object.freeze({
  PENDING: 'pending',
  READY: 'ready',
  FAILED: 'failed',
});

/**
 * Library asset types used by Bunny-backed library assets.
 * Keep in sync with consumers that filter by assetType.
 */
export const LIBRARY_ASSET_TYPE = Object.freeze({
  BRAND_ASSETS: 'brand assets',
  CONTRACT: 'contract',
  PRODUCTION_SCHEDULE: 'production-schedule',
  BRIEF_ATTACHMENT: 'brief-attachment',
});
